/* global Year */

const Copyright = () => (
    <p className="is-centered">
        {`${Year} © Monday Publishing`}
    </p>
);

export default Copyright;
